import React, { useState } from "react";

import Loader from "utilities/Loader";

import { getTours, getReservation } from "services/reservation";

const ReservationContext = React.createContext({
  reservations: [
    {
      id: -1,
      mtm: 0,
      tour: {
        id: -1,
        title: "",
        mainprice: 0,
        main_status: 0,
        stm: "",
        trasportType: "",
      },
      buyer: {
        id: -1,
        fullname: "",
        mobile: 0,
        codemelli: 0,
        seat_number: "",
      },
      passangers: [
        {
          id: -1,
          fullname: "",
          mobile: 0,
          codemelli: 0,
          seat_number: "",
        },
      ],
      factor: {
        id: -1,
        total_amt: 0,
        total_count: 0,
        total_discount: 0,
        total_paid: 0,
      },
      additionalCost: [
        {
          id: 0,
          title: "",
          cost: 0,
          discount: 0,
        },
      ],
    },
  ],
  tours: [
    {
      id: -1,
      title: "",
      duration: "",
      transferType: "",
      trasportType: "",
      mainprice: 0,
    },
  ],
  getInfo: async (conditions) => {},
  getFactors: async () => {},
  loadingHandler: () => {},
});
export default ReservationContext;

export function ReservationContextProvider({ children, uid = -1 }) {
  const [reservations, setReservations] = useState([
    {
      id: -1,
      mtm: 0,
      tour: {
        id: -1,
        title: "",
        mainprice: 0,
        main_status: 0,
        stm: "",
        trasportType: "",
      },
      buyer: {
        id: -1,
        fullname: "",
        mobile: 0,
        codemelli: 0,
        seat_number: "",
      },
      passangers: [
        {
          id: -1,
          fullname: "",
          mobile: 0,
          codemelli: 0,
          seat_number: "",
        },
      ],
      factor: {
        id: -1,
        total_amt: 0,
        total_count: 0,
        total_discount: 0,
        total_paid: 0,
      },
      additionalCost: [
        {
          id: 0,
          title: "",
          cost: 0,
          discount: 0,
        },
      ],
    },
  ]);
  const [tours, setTours] = useState([
    {
      id: -1,
      title: "",
      duration: "",
      transferType: "",
      mainprice: 0,
    },
  ]);
  const [loading, setLoading] = useState(true);

  function loadingHandler(state) {
    setLoading(state);
  }

  async function getInfo(conditions) {
    let res = await getTours(conditions);
    setTours(res);
  }

  async function getFactors() {
    let res;
    if (uid == -1) res = await getReservation();
    else res = await getReservation(uid);
    setReservations(res);
  }

  return (
    <ReservationContext.Provider
      value={{
        reservations,
        tours,
        getInfo,
        getFactors,
        loadingHandler,
      }}
    >
      {loading ? <Loader /> : ""}
      {children}
    </ReservationContext.Provider>
  );
}
